import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { categories } from "@/mocks/gossip";

const accentRotation = [
  "bg-primary-100 text-primary-800",
  "bg-accent-100 text-accent-800",
  "bg-secondary-100 text-secondary-900",
];

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-100" aria-labelledby="category-title">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <h2 id="category-title" className="sr-only">
          主题分类
        </h2>
        <SectionHeading
          kicker="按主题围观"
          title="主题分类"
          desc="想蹲哪一类瓜，就到对应的板块里翻。每个分类都会持续补充新的时间线，不会只留一条孤零零的爆料。"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((category, index) => (
            <Link
              key={category.id}
              to={`/plaza?category=${category.id}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-lg ${
                    accentRotation[index % accentRotation.length]
                  }`}
                >
                  <i className={`${category.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="text-xs text-foreground-400">{category.count} 条</span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                {category.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {category.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-700">
                进入板块
                <i
                  className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5"
                  aria-hidden="true"
                ></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}